import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "autocomplete-panel",
  ref: "appPanel"
}
const _hoisted_2 = {
  key: 0,
  class: "autocomplete-source"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "people", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" People ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "task", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Tasks ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "today", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Dates ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "price_change", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Cost Centers ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "autocomplete-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppEditorItem = _resolveComponent("AppEditorItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isOpen)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.collections, (collection) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `source-${collection.source.sourceId}`
          }, [
            (collection.items.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (collection.source.sourceId === 'user-source')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _hoisted_6))
                    : (collection.source.sourceId === 'task-source')
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _hoisted_10))
                      : (collection.source.sourceId === 'date-source')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_11, _hoisted_14))
                        : (collection.source.sourceId === 'center-source')
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_15, _hoisted_18))
                          : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collection.items, (item, idx) => {
                      return (_openBlock(), _createElementBlock("li", { key: idx }, [
                        _createVNode(_component_AppEditorItem, {
                          item: item,
                          itemProps: _ctx.itemProps(item, collection.source)
                        }, null, 8, ["item", "itemProps"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      : _createCommentVNode("", true)
  ], 512))
}